import { put, call, takeEvery, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators as AppCreators } from '../../reducers/app';
import { Types, Creators } from '../../reducers/customer';
import { getUserInfo } from '../../utils/cookiesUser';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* customerOrdersRequest({ pagination = 0, last }) {
  try {
    const token = yield select(getToken);
    const { customer, app } = yield select(getState);
    const { id } = getUserInfo();
    const siteId = app.getIn(['config', 'siteId']);
    const customerId = customer.id || id;
    let query = null;

    if (pagination) {
      query = {
        offset: `${pagination}0`,
        limit: 10,
      };
    }

    const data = yield call(customerAPI.orders, customerId, token, last, query, siteId);

    yield put(Creators.customerOrdersSuccess(data));
  } catch (error) {
    const formatted = formatError(error);
    yield put(Creators.customerOrdersFailed(formatted));
    yield put(AppCreators.feedbackRequest({ open: true, message: formatted.message }));
  }
}

export default function* watch() {
  yield takeEvery(Types.CUSTOMER_ORDERS_REQUEST, customerOrdersRequest);
}
